import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { ApiQuery } from '../../../../common/model/api.query';
import { documentLocalization } from '../../document/model/document.fragments';
import { userModuleAnswerQuestion } from '../../module/model/page/question/module-question.fragments';
import { UserModuleAnswerOutput } from '../model/user-module-answer.output';

export interface FetchUserModulesAnswersInput {
	readonly reportJobOfferId?: string;
	readonly orgModulesId?: string[];
	readonly questionsId?: string[];
	readonly allContacts?: boolean;
	readonly reportTaskId?: string;
	readonly contactId?: string;
	readonly userId: string;
}

export interface FetchUserModulesAnswersParams {
	input: FetchUserModulesAnswersInput;
}

@Injectable({ providedIn: 'root' })
export class FetchUserModulesAnswersApiQuery extends ApiQuery<
	UserModuleAnswerOutput[],
	FetchUserModulesAnswersParams
> {
	client = 'content';
	document = gql`
		query FetchUserModulesAnswers($input: FetchUserModulesAnswersInput!) {
			fetchUserModulesAnswers(input: $input) {
				id
				type
				value
				pageId
				userId
				moduleId
				contactId
				orgModuleId
				reportTaskId
				reportJobOfferId
				updateTimestamp
				task {
					id
					label
					userTaskId
					dueTimestamp
				}
				article {
					id
				}
				question {
					...UserModuleAnswerQuestion
				}
				document {
					id
					type
					updateTimestamp
					localizations {
						...DocumentLocalization
					}
					lastOpenTimestamp
					creationTimestamp
				}
			}
		}
		${documentLocalization}
		${userModuleAnswerQuestion}
	`;
	method = 'fetchUserModulesAnswers';
}
